import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


document.addEventListener("DOMContentLoaded", function () {
  const faqs = document.querySelectorAll(".faq-item");

  faqs.forEach((faq) => {
    const question = faq.querySelector(".faq-title-wrapper");
    const answer = faq.querySelector(".faq-item-description-wrapper");
    const openIcon = faq.querySelector(".handle-open-item");
    const closeIcon = faq.querySelector(".handle-close-item");

    question.addEventListener("click", function () {
      // Close all other FAQ items
      faqs.forEach((item) => {
        if (item !== faq) {
          item.querySelector(".faq-item-description-wrapper").classList.remove("show");
          item.querySelector(".handle-open-item").classList.remove("hideIcon");
          item.querySelector(".handle-close-item").classList.add("hideIcon");
        }
      });

      // Toggle the current FAQ item
      answer.classList.toggle("show");
      openIcon.classList.toggle("hideIcon");
      closeIcon.classList.toggle("hideIcon");
    });
  });
});


function initFaqSection(section) {
  if (section.dataset.wvAnimInited === "1") return;
  section.dataset.wvAnimInited = "1";

  const title = section.querySelector("h2.global_title");
  const desc = section.querySelector(".wv-faq-description");
  const items = gsap.utils.toArray(section.querySelectorAll(".faq-item"));
  const decor = section.querySelector(".wv-decor");

  if (title) gsap.set(title, { autoAlpha: 0, y: 40 });
  if (desc) gsap.set(desc, { autoAlpha: 0, y: 30 });
  if (decor) gsap.set(decor, { autoAlpha: 0, scale: 0.95 });

  gsap.set(items, { autoAlpha: 0, y: 50 });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 75%",
      once: true,
    },
  });

  if (title) {
    tl.to(title, {
      autoAlpha: 1,
      y: 0,
      duration: 0.8,
      ease: "power3.out",
    });
  }

  if (desc) {
    tl.to(
      desc,
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
      },
      0.15
    );
  }

  tl.to(
    items,
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.8,
      ease: "power4.out",
      stagger: 0.18, 
    },
    0.3
  );

  if (decor) {
    tl.to(
      decor,
      {
        autoAlpha: 1,
        scale: 1,
        duration: 0.8,
        ease: "power3.out",
      },
      0.2
    );

    gsap.to(decor, {
      y: 12,
      duration: 6,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      delay: 1,
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".wp-block-blocks-webvibe-block-faq")
    .forEach(initFaqSection);
});